import Vue from 'vue';
import { runtime } from './bridge';
import { siteAccount, readCloudLibraryIndex, writeCloudLibraryIndex } from './site-account';
import { createLibraryCloudSync } from './library-cloud-sync';

export const libraryCloudSync = createLibraryCloudSync({
  getSnapshot: () => runtime.libraryCloudSnapshot(),
  getAccount: () => siteAccount.user ? { id: siteAccount.user.id, revision: siteAccount.revision } : null,
  readRemote: readCloudLibraryIndex,
  writeRemote: writeCloudLibraryIndex,
  applySnapshot: (backup, guard) => runtime.mergeCloudLibrary(backup, guard),
  storage: localStorage,
});
Vue.observable(libraryCloudSync.state);
let stop: (() => void) | null = null;

/** Activate the expensive index observer only for an opted-in, signed-in user. */
export function startLibraryCloudSync() {
  if (stop) return stop;
  const observer = new Vue();
  let unwatchIndex: (() => void) | undefined;
  const watchIndex = () => {
    const enabled = siteAccount.ready && Boolean(siteAccount.user) && libraryCloudSync.state.mode === 'cloud';
    if (!enabled) { unwatchIndex?.(); unwatchIndex = undefined; return; }
    if (unwatchIndex) return;
    unwatchIndex = observer.$watch(() => [runtime.state.tracks, runtime.state.favorites, runtime.state.playlists, runtime.state.history, runtime.state.historyPlayedAt, runtime.state.lyrics, runtime.state.notice], () => libraryCloudSync.notifyLocalChange(), { deep: true });
  };
  const unwatchAccount = observer.$watch(() => [siteAccount.ready, siteAccount.user?.id, siteAccount.revision], () => {
    if (siteAccount.ready) void libraryCloudSync.refreshAccount().then(watchIndex);
    watchIndex();
  }, { immediate: true });
  const unwatchMode = observer.$watch(() => libraryCloudSync.state.mode, watchIndex);
  const onStorage = (event: StorageEvent) => { if (event.key === 'mineradio.state.v1') libraryCloudSync.notifyLocalChange(); };
  window.addEventListener('storage', onStorage);
  stop = () => { unwatchIndex?.(); unwatchAccount(); unwatchMode(); observer.$destroy(); window.removeEventListener('storage', onStorage); libraryCloudSync.dispose(); stop = null; };
  return stop;
}
